import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormGroupTextComponent } from './form-group-text/form-group-text.component';
import { FormGroupPassComponent } from './form-group-pass/form-group-pass.component';
import { FormGroupSelectComponent } from './form-group-select/form-group-select.component';
import { FormGroupSearchComponent } from './form-group-search/form-group-search.component';
import { FormGroupSelectSearchComponent } from './form-group-select-search/form-group-select-search.component';
import { NgSelect2Module } from 'ng-select2';
import { FormGroupSliderComponent } from './form-group-slider/form-group-slider.component';
import { NouisliderModule } from 'ng2-nouislider';
import { FilterTagSliderComponent } from './filter-tag-slider/filter-tag-slider.component';
import { FilterTagTextComponent } from './filter-tag-text/filter-tag-text.component';
import { DivValidationMessageComponent } from './div-validation-message/div-validation-message.component';
import { InputTextComponent } from './input-text/input-text.component';
import { InputSelectComponent } from './input-select/input-select.component';
import { InputSelectSearchComponent } from './input-select-search/input-select-search.component';
import { InputTextAreaComponent } from './input-text-area/input-text-area.component';
import { FormGroupDateComponent } from './form-group-date/form-group-date.component';
import { InputDateComponent } from './input-date/input-date.component';
import { InputRadioComponent } from './input-radio/input-radio.component';
import { FilterTagCheckboxComponent } from './filter-tag-checkbox/filter-tag-checkbox.component';
import { InputRatingComponent } from './input-rating/input-rating.component';
import { InputCheckComponent } from './input-check/input-check.component';
import { FormGroupUploadBoxComponent } from './form-group-upload-box/form-group-upload-box.component';
import { FormGroupTermsComponent } from './form-group-terms/form-group-terms.component';
import { FormGroupTextAreaComponent } from './form-group-text-area/form-group-text-area.component';
import { FormGroupNumberComponent } from './form-group-number/form-group-number.component';
import { InputNumberComponent } from './input-number/input-number.component';
import { QuillModule } from 'ngx-quill';
import { InputTextRichComponent } from './input-text-rich/input-text-rich.component';
import { FormGroupTextRichComponent } from './form-group-text-rich/form-group-text-rich.component'
import { FormGroupUploadBoxMultipleComponent } from './form-group-upload-box-multiple/form-group-upload-box-multiple.component';
import { InputFileUploadComponent } from './input-file-upload/input-file-upload.component';
import { InputTextMapsComponent } from './input-text-maps/input-text-maps.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { FormGroupUploadBoxCropperComponent } from './form-group-upload-box-cropper/form-group-upload-box-cropper.component';
import { ModalImageCropperComponent } from './modal-image-cropper/modal-image-cropper.component';
import { InputImageCropperComponent } from './input-image-cropper/input-image-cropper.component';
import { InputSliderComponent } from './input-slider/input-slider.component';
import { MaterialModule } from '../material/material.module';
import { FormGroupCheckboxMultiComponent } from './form-group-checkbox-multi/form-group-checkbox-multi.component';
import { FilterTagCheckboxMultiComponent } from './filter-tag-checkbox-multi/filter-tag-checkbox-multi.component';
import { InputSliderNolinearComponent } from './input-slider-nolinear/input-slider-nolinear.component';
import { FormGroupSliderNolinearComponent } from './form-group-slider-nolinear/form-group-slider-nolinear.component';
import { FormGroupCheckboxMultiGroupComponent } from './form-group-checkbox-multi-group/form-group-checkbox-multi-group.component';
import { InputDateMonthComponent, InputDateMonthHeaderComponent } from './input-date-month/input-date-month.component';
import { InputCurrencyComponent } from './input-currency/input-currency.component';
import { InputNumberDecimalComponent } from './input-number-decimal/input-number-decimal.component';
import { InputPhoneComponent } from './input-phone/input-phone.component';
import { FormGroupPhoneComponent } from './form-group-phone/form-group-phone.component'
import { PipesModule } from '@app/pipes/pipes.module';
import { FilterTagRadioComponent } from './filter-tag-radio/filter-tag-radio.component';
import { FormGroupCheckboxMultiAccordionComponent } from './form-group-checkbox-multi-accordion/form-group-checkbox-multi-accordion.component';
import { FilterTagSelectComponent } from './filter-tag-select/filter-tag-select.component';
import { FormGroupRadioMultiComponent } from './form-group-radio-multi/form-group-radio-multi.component';
import { FormGroupRadioMultiAccordionComponent } from './form-group-radio-multi-accordion/form-group-radio-multi-accordion.component';
import { FormGroupCheckboxMultiLevelComponent } from './form-group-checkbox-multi-level/form-group-checkbox-multi-level.component';
import { FilterTagCheckboxLevelComponent } from './filter-tag-checkbox-level/filter-tag-checkbox-level.component';
import { FormGroupTimeComponent } from './form-group-time/form-group-time.component';
import { InputTimeComponent } from './input-time/input-time.component';
import { FilterTagRadioMultiComponent } from './filter-tag-radio-multi/filter-tag-radio-multi.component';
import { InputDomainComponent } from './input-domain/input-domain.component';
import { DirectivesModule } from '@app/directives/directives.module';
import { FormGroupCheckboxGroupedComponent } from './form-group-checkbox-grouped/form-group-checkbox-grouped.component';
import { FilterTagCheckboxGroupedComponent } from './filter-tag-checkbox-grouped/filter-tag-checkbox-grouped.component';

@NgModule({
  imports: [
    PipesModule,
    MaterialModule,
    ImageCropperModule,
    FormsModule,
    DirectivesModule,
    ReactiveFormsModule,
    CommonModule,
    NgSelect2Module,
    NouisliderModule,
    QuillModule.forRoot({
      customOptions: [{
        import: 'formats/font',
        whitelist: ['mirza', 'roboto', 'aref', 'serif', 'sansserif', 'monospace']
      }]
    })
  ],
  declarations: [
    InputDomainComponent,
    FilterTagRadioMultiComponent,
    DivValidationMessageComponent,
    FilterTagCheckboxComponent,
    FilterTagCheckboxMultiComponent,
    FilterTagRadioComponent,
    FilterTagSliderComponent,
    FilterTagTextComponent,
    FormGroupCheckboxMultiAccordionComponent,
    FormGroupCheckboxMultiComponent,
    FormGroupCheckboxMultiGroupComponent,
    FormGroupDateComponent,
    FormGroupNumberComponent,
    FormGroupPassComponent,
    FormGroupPhoneComponent,
    FormGroupSearchComponent,
    FormGroupSelectComponent,
    FormGroupSelectSearchComponent,
    FormGroupSliderComponent,
    FormGroupSliderNolinearComponent,
    FormGroupTermsComponent,
    FormGroupTextAreaComponent,
    FormGroupTextComponent,
    FormGroupTextRichComponent,
    FormGroupUploadBoxComponent,
    FormGroupUploadBoxCropperComponent,
    FormGroupUploadBoxMultipleComponent,
    InputCheckComponent,
    InputCurrencyComponent,
    InputDateComponent,
    InputDateMonthComponent,
    InputDateMonthHeaderComponent,
    InputFileUploadComponent,
    InputImageCropperComponent,
    InputNumberComponent,
    InputNumberDecimalComponent,
    InputPhoneComponent,
    InputRadioComponent,
    InputRatingComponent,
    InputSelectComponent,
    InputSelectSearchComponent,
    InputSliderComponent,
    InputSliderNolinearComponent,
    InputTextAreaComponent,
    InputTextComponent,
    InputTextMapsComponent,
    InputTextRichComponent,
    ModalImageCropperComponent,
    FilterTagSelectComponent,
    FormGroupRadioMultiComponent,
    FormGroupRadioMultiAccordionComponent,
    FormGroupCheckboxMultiLevelComponent,
    FilterTagCheckboxLevelComponent,
    FormGroupTimeComponent,
    InputTimeComponent,
    FormGroupCheckboxGroupedComponent,
    FilterTagCheckboxGroupedComponent
  ],
  exports: [
    InputDomainComponent,
    FilterTagRadioMultiComponent,
    DivValidationMessageComponent,
    FilterTagCheckboxComponent,
    FilterTagCheckboxMultiComponent,
    FilterTagRadioComponent,
    FilterTagSliderComponent,
    FilterTagTextComponent,
    FormGroupCheckboxMultiAccordionComponent,
    FormGroupCheckboxMultiComponent,
    FormGroupCheckboxMultiGroupComponent,
    FormGroupDateComponent,
    FormGroupNumberComponent,
    FormGroupPassComponent,
    FormGroupPhoneComponent,
    FormGroupSearchComponent,
    FormGroupSelectComponent,
    FormGroupSelectSearchComponent,
    FormGroupSliderComponent,
    FormGroupSliderNolinearComponent,
    FormGroupTermsComponent,
    FormGroupTextAreaComponent,
    FormGroupTextComponent,
    FormGroupTextRichComponent,
    FormGroupUploadBoxComponent,
    FormGroupUploadBoxCropperComponent,
    FormGroupUploadBoxMultipleComponent,
    InputCheckComponent,
    InputCurrencyComponent,
    InputDateComponent,
    InputDateMonthComponent,
    InputDateMonthHeaderComponent,
    InputFileUploadComponent,
    InputImageCropperComponent,
    InputNumberComponent,
    InputNumberDecimalComponent,
    InputPhoneComponent,
    InputRadioComponent,
    InputRatingComponent,
    InputSelectComponent,
    InputSelectSearchComponent,
    InputSliderComponent,
    InputSliderNolinearComponent,
    InputTextAreaComponent,
    InputTextComponent,
    InputTextMapsComponent,
    InputTextRichComponent,
    ModalImageCropperComponent,
    FilterTagSelectComponent,
    FormGroupRadioMultiComponent,
    FormGroupRadioMultiAccordionComponent,
    FormGroupCheckboxMultiLevelComponent,
    FilterTagCheckboxLevelComponent,
    FormGroupTimeComponent,
    InputTimeComponent,
    FormGroupCheckboxGroupedComponent,
    FilterTagCheckboxGroupedComponent
  ]
})
export class FormGroupModule { }
